import { gql } from '@apollo/client';

const trims = {
  GET_TRIM_LEVELS: gql`
    query GetTrimLevels($trimCode: TrimCode!) {
      trimLevels(trimCode: $trimCode) {
        id
        label
        type
      }
    }
  `,
};

export default trims;
